import { configureStore } from '@reduxjs/toolkit';
import { createEpicMiddleware } from 'redux-observable';
import * as Sentry from '@sentry/react';
import rootReducer from '@reducers/rootReducer';
import rootEpic from '@actions/rootEpic';
import { localStoreSync } from '@support/localStore';
import { injectStore } from '@support/isStarred';
import { enableBatching } from 'redux-batched-actions';
import { appAlerts } from '@support/appAlerts';
import { syncRemoteDeviceIntegrationChangesToDesktopApp } from '@actions/deviceIntegrations';
import { syncUserStateToDesktopApp } from '@reducers/user/account';
import { uiStateChangeSideEffects } from '@actions/ui';

// Our redux store and app history are dependent on one another, so we create
// both at once here
const initializeStore = () => {
  const epicMiddleware = createEpicMiddleware();
  const store = configureStore({
    reducer: enableBatching(rootReducer),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }).concat(
        epicMiddleware,
        appAlerts,
        localStoreSync,
        syncRemoteDeviceIntegrationChangesToDesktopApp,
        syncUserStateToDesktopApp,
        uiStateChangeSideEffects,
      ),
    enhancers: (getDefaultEnhancers) =>
      getDefaultEnhancers().concat(Sentry.createReduxEnhancer({})),
  });

  epicMiddleware.run(rootEpic);
  return store;
};

export const store = initializeStore();

// Pass store for use in the isStarred handler
injectStore(store);
